import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
import { SparkleDecoration } from './ui/SparkleDecoration';
const faqs = [{
  q: '¿En qué formato recibo el Mega Pack?',
  a: 'Formato digital PDF, descargable desde cualquier dispositivo. Podés leerlo en tu celular, tablet, computadora o imprimirlo si preferís el papel.'
}, {
  q: '¿Necesito experiencia previa para aplicarlo?',
  a: 'No, está diseñado para cualquier mamá, sin importar su experiencia. Las guías son paso a paso, simples y directas al punto.'
}, {
  q: '¿Funciona si trabajo todo el día?',
  a: 'Sí, las rutinas están pensadas especialmente para mamás con poco tiempo disponible. El objetivo es optimizar el tiempo que sí tenés.'
}, {
  q: '¿Y si no me sirve?',
  a: 'Tenés 7 días de garantía. Si no te convence o sentís que no se adapta a tu familia, te devolvemos el 100% de tu dinero sin hacer preguntas.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'Inmediatamente después de tu compra, recibís el acceso por email. Podés empezar a leer y aplicar los consejos hoy mismo.'
}, {
  q: '¿Puedo compartirlo con otras mamás?',
  a: 'La licencia es personal e intransferible, pero podés recomendarnos para que ellas también aprovechen esta oferta especial.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-14 bg-cream relative" data-id="element-37">
      <div className="max-w-sm mx-auto px-4" data-id="element-38">
        <AnimatedSection className="text-center mb-8 relative" data-id="element-39">
          <div className="inline-block relative" data-id="element-40">
            <h2 className="text-xl md:text-2xl font-serif font-bold text-charcoal" data-id="element-41">
              Preguntas frecuentes
            </h2>
            <div className="absolute -top-4 -right-6" data-id="element-42">
              <SparkleDecoration size={18} color="#E8735A" data-id="element-43" />
            </div>
          </div>
        </AnimatedSection>

        <div className="space-y-2.5" data-id="element-44">
          {faqs.map((faq, index) => <AnimatedSection key={index} delay={index * 0.06} data-id="element-45">
              <div className={`bg-white rounded-xl border transition-colors duration-300 overflow-hidden ${openIndex === index ? 'border-coral shadow-md' : 'border-rose/30 shadow-sm hover:border-coral/50'}`} data-id="element-46">
                <button onClick={() => toggleFAQ(index)} className="w-full px-4 py-3 text-left flex justify-between items-center focus:outline-none" data-id="element-47">
                  <span className="font-bold text-charcoal text-xs pr-3" data-id="element-48">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-coral transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={16} data-id="element-49" />
                </button>
                <AnimatePresence data-id="element-50">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-51">
                      <div className="px-4 pb-3 text-charcoal/65 text-xs leading-relaxed" data-id="element-52">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}